import { WSIcons } from "../../commonFunctions/iIcons";

export const getMenu: any = (userType: string) => {
  return {
    staticMenu:
      userType === "admin1"
        ? [
          {
            id: 1,
            label: "Home",
            icon: WSIcons.Home,
            path: "/home"
          },
          {
            id: 2,
            label: "Masters",
            icon: WSIcons.Masters,
            children: [
              {
                id: 3,
                label: "Banner",
                path: "/banner/list"
              },
              {
                id: 4,
                label: "Designations",
                path: "/designations"
              },

            ]
          },

          {
            id: 9,
            label: "Products",
            icon: WSIcons.PersonOffIcon,
            children: [
              {
                id: 9,
                label: "Product List",
                path: "/product/list"
              },
              {
                id: 10,
                label: "Wish List",
                path: "/wish/list"
              }
            ]
          },

          {
            id: 13,
            label: "Settings",
            icon: WSIcons.SettingsIcon,
            children: [
              {
                id: 14,
                label: "Organization",
                path: "/organization/view"
              },
              {
                id: 15,
                label: "Change Password",
                path: "/changepassword"
              }
            ]
          }
        ]
        : [
          {
            id: 1,
            label: "Home",
            icon: WSIcons.Home,
            path: "/user/list"
          },

          {
            id: 2,
            label: "Masters",
            icon: WSIcons.AllInclusiveOutlinedIcon,
            children: [
              {
                id:21 ,
                label: "Specialization",
                path: "/specialization/list"
              },
{
                id:22 ,
                label: "Qualification",
                path: "/qualification/list"
              },
              {
                id:23 ,
                label: "Symptoms",
                path: "/symptoms/list"
              },
              // {
              //   id:24 ,
              //   label: "Brand",
              //   path: "/brand/list"
              // },
              {
                id:25 ,
                label: "Doctor Service",
                path: "/doctor-service/list"
              },
              // {
              //   id:26 ,
              //   label: "Vendor Service",
              //   path: "/vendor-service/list"
              // },
              //  {
              //   id:27 ,
              //   label: "Vendor Type",
              //   path: "/vendor-type/list"
              // },

              {
                id:28 ,
                label: "Users",
                path: "/user/list"
              },

               {
                id:29 ,
                label: "Medical Category",
                path: "/medical-category/list"
              },

            ]
          },

          {
            id: 3,
            label: "Contacts",
            icon:WSIcons.CallIcon,
            path: "/contact/list"
          },
           {
            id: 4,
            label: "Transactions",
            icon: WSIcons.Transactoions,
            children: [
              {
                id:41 ,
                label: "Bookings",
                path: "/booking/list"
              },
            ]
          },
             {
            id: 5,
            label: "Wallets",
            icon: WSIcons.WalletOutlinedIcon,
            children: [
              {
                id:51 ,
                label: "Wallet",
                path: "/wallet/list"
              },
              {
                id:51 ,
                label: "Withdrawal",
                path: "/withdrawal/list"
              },
            ]
          }
        ]
  };
};
